import { registerComponent } from './components-front'

registerComponent('heading', _ => {
    document.querySelectorAll('.purge-empty-text').forEach(el => {
        if (el.innerText === '') {
            if (el.parentElement) {
                el.parentElement.removeChild(el)
            }
        }
    })
})
